import { useState } from 'react';
import { Container } from 'react-bootstrap';
import { useLocation } from 'react-router-dom';
import { useAuth0 } from '@auth0/auth0-react';
import Sidebar from '../components/Sidebar';
import TopNavbar from '../components/TopNavbar';
import Footer from '../components/Footer';

function DashboardLayout({ children }) {
  const [sidebarCollapsed, setSidebarCollapsed] = useState(false);
  const location = useLocation();
  const currentPage = location.pathname.slice(1);
  const { isLoading } = useAuth0();

  const toggleSidebar = () => {
    setSidebarCollapsed(!sidebarCollapsed);
  };

  if (isLoading) {
    return (
      <div
        className="d-flex justify-content-center align-items-center"
        style={{ minHeight: '100vh' }}
      >
        <div className="spinner-border text-primary" role="status">
          <span className="visually-hidden">Loading...</span>
        </div>
      </div>
    );
  }

  return (
    <div className="app-container">
      <TopNavbar toggleSidebar={toggleSidebar} />
      <div className="content-wrapper">
        <Sidebar collapsed={sidebarCollapsed} currentPage={currentPage} />
        <main className={`main-content ${sidebarCollapsed ? 'expanded' : ''}`}>
          <Container fluid className="py-4">
            {children}
          </Container>
        </main>
      </div>
      <Footer />
    </div>
  );
}

export default DashboardLayout;
